/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface InlineResponse200StatusInfo
 */
export interface InlineResponse200StatusInfo {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200StatusInfo
     */
    family?: InlineResponse200StatusInfoFamilyEnum;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200StatusInfo
     */
    reasonPhrase?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200StatusInfo
     */
    statusCode?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse200StatusInfoFamilyEnum {
    Informational = 'INFORMATIONAL',
    Successful = 'SUCCESSFUL',
    Redirection = 'REDIRECTION',
    ClientError = 'CLIENT_ERROR',
    ServerError = 'SERVER_ERROR',
    Other = 'OTHER'
}



